import styled from 'styled-components'

import { colors } from '../../../../../../shared/styles/colors'

export const Title = styled.span`
  font-weight: 700;
  font-size: 16px;
`

export const Subtitle = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: ${colors.grayDark};
`

export const DetalhesMotorista = styled.div`
  background-color: ${colors.white};
  color: ${colors.grayDark};
  padding-top: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
`

export const DetalhesVeiculo = styled.div`
  background-color: ${colors.white};
  color: ${colors.grayDark};
  padding-top: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
`

export const DetalhesCabecalho = styled.div`
  background-color: ${colors.greenDark2};
  color: ${colors.white};
  padding-top: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
`

export const SideBar = styled.div`
  position: absolute;
  right: 0;
  top: 20;
  z-index: 100;
  background: ${colors.white};
  width: 43%;
  height: 100vh;
  box-shadow: -2px 8px 11px 1px rgba(0, 0, 0, 0.31);
  transition: width 0.35s;
  overflow: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(36, 169, 93, 1);
    border-radius: 70px;
  }
`

export const Label = styled.span`
  font-weight: 600;
  font-size: 14px;
`

export const Value = styled.span`
  font-weight: 400;
  font-size: 14px;
`

export const HorizontalLine = styled.hr`
  border: 0;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
`
